declare namespace $ {

	export class $shm_hotkey_mark extends $mol_view {
		label( ): string
		anchor( ): string
		sub( ): readonly(any)[]
		attr( ): ({ 
			'aria-hidden': string,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'positionAnchor': ReturnType< $shm_hotkey_mark['anchor'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
}

//# sourceMappingURL=mark.view.tree.d.ts.map